import React, { FC, useEffect, useRef } from "react";
import { Text, Linking } from "react-native";

interface Props {
  text: string;
  fontSize?: number;
  setClickedUrl?: React.Dispatch<React.SetStateAction<string>>;
  setShowConfirmLinkPopup?: React.Dispatch<React.SetStateAction<boolean>>;
}

const AVlinktext: FC<Props> = ({
  text,
  fontSize = 15,
  setClickedUrl,
  setShowConfirmLinkPopup,
}) => {
  const linkRegex = /(https?:\/\/[^\s]+)/g;
  const emailRegex =
    /^[a-zA-Z0-9!#$%&'+^_`{}~-]+(?:\.[a-zA-Z0-9!#$%&'+^_`{}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  const phoneRegex = /^[0-9]{10}$/;
  const textParts = text?.trim()?.length > 0 ? text?.split(linkRegex) : [];

  const hasLinks = linkRegex.test(text);
  const postRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = postRef.current;
    if (!el || !hasLinks) return;

    const handleLinkClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a");

      if (anchor) {
        e.preventDefault();
        e.stopPropagation();
        const href = (anchor as HTMLAnchorElement).href;
        if (href) {
          setClickedUrl?.(href);
          setShowConfirmLinkPopup?.(true);
        }
      }
    };

    el.addEventListener("click", handleLinkClick);
    return () => el.removeEventListener("click", handleLinkClick);
  }, [hasLinks]);

  return (
    <div ref={postRef}>
      <Text style={{ fontSize, padding: 1, paddingHorizontal: 2 }}>
        {textParts.map((part, index) => {
          // Handle plain URLs
          if (part.match(linkRegex)) {
            return (
              <Text
                key={index}
                onPress={() => {
                  // Instead of opening directly, show confirm popup
                  setClickedUrl?.(part);
                  setShowConfirmLinkPopup?.(true);
                }}
                style={{ color: "blue", textDecorationLine: "underline" }}
              >
                {part}
              </Text>
            );
          }

          // Handle emails and phone numbers directly (no confirm popup)
          if (part.match(emailRegex)) {
            return (
              <Text
                key={index}
                onPress={() => Linking.openURL(`mailto:${part}`)}
                style={{ color: "blue", textDecorationLine: "underline" }}
              >
                {part}
              </Text>
            );
          }

          if (part.match(phoneRegex)) {
            return (
              <Text
                key={index}
                onPress={() => Linking.openURL(`tel:${part}`)}
                style={{ color: "blue", textDecorationLine: "underline" }}
              >
                {part}
              </Text>
            );
          }

          // Default: plain text
          return <Text key={index}>{part}</Text>;
        })}
      </Text>
    </div>
  );
};

export default AVlinktext;
